<template>
   <page>
    <template slot="content">
      <q-and-a-content :title="'データの同期（重要）'">
        <template slot="content">
          <div class="text">歩数データが同期されたかどうかを確認したい場合、ホームに表示されている歩数の上の同期時刻を確認してください。<br>
          もし同期時刻が古かった場合、ホームを下スワイプすれば直ちにデータを同期することができます。<br>
          ※未同期のデータがあれば、数秒を待つと自動的に同期されます。<br><br>
          重要：WeRUNアプリが<b>直近最大7日間のデータをスマホに保存</b>できます。長期間同期処理を行わない場合は日付の古い順番でデータが上書きされます。データの紛失を防ぐために、<b>定期的にアプリを開き、同期処理を行う</b>ようにしてください。</div>
          <img class="picture" src="../assets/images/q_and_a/8.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    name: 'QAndACheckDataSync',
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesCheckDataSync.vue